/**
 * Created by Greg on 3/30/2016.
 */
import React from 'react';
import {Modal, Button, Popover, OverlayTrigger, Row, Col, FormControl} from 'react-bootstrap';
import DraggableModalDialog from './../DraggableModal';
import { connect } from 'react-redux';
import {minSpanTree, linkParm, depthFirstConnected} from './PathComputations';


var MinSpanTreeDialog = React.createClass({
    getInitialState() {
        return {pathGroup: null, connected: depthFirstConnected(this.props.net)};
    },

    helpPopover(){
        return (<Popover id="MinSpanTreeHelpPopover" title="Minimum Spanning Tree Help">
            <p>This command computes the minimum spanning tree for a <em>connected</em>
                network and returns the result as a set of single link paths for easy
                visualization. Use the <strong>Add</strong> button to add this group of paths to
            the application, then you can examine the tree via the Paths Info panel.</p>
        </Popover>)
    },
    
    applyHandler() {
        if (this.state.pathGroup) {
            this.props.pathCollectionAdd(this.state.pathGroup);
        }
    },

    computeHandler() {
        let net = this.props.net;
        // console.log("Is network connected: " + depthFirstConnected(net));
        if (!depthFirstConnected(net)) {return};
        let tree = minSpanTree(net);
        // Create a path group from the tree branches
        let pathGroup = {id: "MinSpanTree", desc: "Minimum spanning tree as a set of link-paths"};
        let pathList = [];
        for (let t of tree) {
            let pathObj = {nodeList: t, cost: linkParm(net, t[0], t[1], 'weight'),
                            capacity: linkParm(net, t[0], t[1], 'capacity' )};
            pathList.push(pathObj);
        }
        pathGroup.pathList = pathList;
        this.setState({pathGroup: pathGroup});
    },

    componentWillReceiveProps(nextProps) {
        this.setState({pathGroup: null, connected: depthFirstConnected(nextProps.net)});
    },

    textAreaValue() {
        if (this.state.pathGroup) {
            return JSON.stringify(this.state.pathGroup, null, 2);
        }
        if (!this.state.connected) {
            return "Cannot compute tree, Network is disconnected";
        }
        return "";
    },

    render(){
        return(
        <Modal show={this.props.open} onHide={this.props.close} dialogClassName="min-span-modal"
               dialogComponentClass={DraggableModalDialog}
           enforceFocus={false} backdrop={false} >
            <Modal.Header closeButton>
                <Modal.Title>Minimum Spanning Tree</Modal.Title>
            </Modal.Header>
            <Modal.Body style={{paddingBottom: 0}}>
                <form className="form-horizontal">
                    <FormControl componentClass="textarea" readOnly
                                 value={this.textAreaValue()}
                                 rows={5} style={{resize: "none"}}/>
                 </form>
            </Modal.Body>
            <Modal.Footer>
                <Button bsStyle="primary"
                            onClick={this.computeHandler} disabled={!this.state.connected}>Compute </Button>
                <Button onClick={this.applyHandler} disabled={!Boolean(this.state.pathGroup)}  >Add</Button>
                <OverlayTrigger trigger="click" placement="top" overlay={this.helpPopover()}>
                    <Button bsStyle={'info'}>Help</Button>
                </OverlayTrigger>
            </Modal.Footer>
            </Modal> 
    )}
});



const mapStateToProps = (state) => {
    return {
        open: state.uiState.showMinTreeModal,
        net: state.net,
        paths: state.paths
    }
};

const mapDispatchToProps = (dispatch) => {
    return {
        close: () => {
            dispatch({type: 'CLOSE_MIN_TREE_DIALOG'});
        },
        pathCollectionAdd: (pathObj) => {
            dispatch({type: 'PATH_COLLECTION_ADD', pathObj: pathObj});
        }

    };
};

export default connect(mapStateToProps, mapDispatchToProps)(MinSpanTreeDialog)




// WEBPACK FOOTER //
// ./src/pathComp/MinSpanTreeDialog.js